function RetireAt59AndHalf() {
  return (
    <div style={{ height: "80vh", width: "100%" }}>
      <h1 className="text-xl font-bold mb-4">Retirement at 59 and a Half</h1>

      <h2 className="text-xl font-bold mb-4">Retire at 55</h2>

      <h2 className="text-xl font-bold mb-4">Retire at 59.5</h2>

      <h3 className="text-xl font-bold mb-4">Phase I: 59.5 - 65</h3>
      <ul>
        <li>ACA health plan
          <ul>
            <li>Low income: $0 - $40k, $80-150/month</li>
            <li>$40k - $80k, $600-800/month</li>
            <li>$80k - $160k, $1600-2200/month</li>
          </ul>
        </li>
        <li> Trade off 
          <ul>
            <li>Roth conversion</li>
            <li>Health insurance cost</li>
          </ul>
        </li>
        <li>Strategy
          <ul>
            <li>Maximize standard deduction</li>
            <li>Utilize 12% bracket</li> 
          </ul> 
        </li>
      </ul>

      <h3 className="text-xl font-bold mb-4">Phase II: 65 - 75</h3>
      <ul>
        <li>Medicare</li>
        <li>SS timing</li>
        <li>Reassess investment strategy</li>
        <li>Reassess withdraw strategy</li>
        <li>Social connection</li>
      </ul>

      <h3 className="text-xl font-bold mb-4">Phase III: 75+</h3>
      <ul>
        <li>LTC</li>
        <li>RMD managed by Ruth + QCD</li>
        <li>Gift</li>
        <li>Estate plan</li>
      </ul>
    </div>
  );
}
export default RetireAt59AndHalf;

